import alt from 'components/Dispatcher';
import { browserHistory } from 'react-router';
import API from 'sources/API';

class LocationActions {
    // 根据选中的 location 获取下一级地址列表，location 为 null 时获取所有的洲
    fetchLocationList(location) {
        return location;
    }
    fetchAllLocationList() {   // 获取所有地址
        return true;
    }
    // 获取 location 详情
    fetchLocation(id,type){
       return {type: type, id: id};
    }
    // 更新备选地址列表
    updateLocationList(locationList) {
        return locationList;
    }
    // 插入更多备选地址列表
    updateMoreLocationList(locationList) {
        return locationList;
    }
    // 获取地址详情成功
    fetchDetailSuccess(data){
        if(data.status === 0){
            this.updateLocation(data.result);
        }else{
            this.fetchFailed(data);
        }
        return data;
    }
    // 获取地址列表成功
    fetchSuccess(data) {
        if(data.status === 0) {
            this.updateLocationList(data.result);
        } else {
            this.fetchFailed(data);
        }
        return data;
    }
    // 获取所有地址列表成功
    fetchAllSuccess(data) {
        if(data.status === 0) {
            this.updateLocationList(data.result);
        } else {
            this.fetchFailed(data);
        }
        return data;
    }
    // 获取失败
    fetchFailed(err) {
        console.log(err);
        if(err.status === 401) {
            if(API.isWechat) {
                location.href = API.redirectWechatLogin;
            } else {
                browserHistory.push('/login');
            }
        }
        return err;
    }
    // 保存当前选中的location
    updateLocation(location) {
        return location;
    }
    // 保存当前 location 的子项
    updateLocations(locations){
        return locations;
    }
    // 保存当前洲
    updateContinent(continent) {
        return continent;
    }
    // 保存当前国家
    updateCountry(country) {
        return country;
    }
    // 保存当前省
    updateState(state) {
        return state;
    }
    // 保存当前城市
    updateCity(city) {
        return city;
    }
    updateRefreshTag(refresh){
        return refresh;
    }
}

export default alt.createActions(LocationActions);



// WEBPACK FOOTER //
// ./src/actions/LocationActions.js